import { Input, Popover } from 'element-ui';
import { EventBus } from '@/services/Event.js';
import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import DisabledValue from '../disabled-value/disabled-value.vue';

export default {
    name: 'TextAnswer',
    inject: {
        highlight_invalid_fields: { default: false }
    },
    props: {
        id: [Number, String],
        value: [Number, String],
        label: String,
        label_class: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
        is_text_copy: { type: Boolean, default: false },
        visible: { type: Boolean, default: true },
        hint: String,
        warning_field_length: String,
        error_messages: Array,
        hint_type: { type: String, default: 'warning' },
        preview: { type: Boolean, default: false },
        email: { type: Boolean, default: false },
        link: { type: Boolean, default: false },
        valid: { type: Boolean, default: true },
        min_length: Number,
        max_length: Number,
        is_mandatory: Boolean,
        is_mandatory_if_visible: Boolean,
        is_text_area: Boolean,
        api: { type: String, default: "" },
        code_value: { type: [String, Number], default: "" },
        update_fields: Array,
        update_fields_map: Array,
        clear_fields: Array,

        placeholder: { type: String, default: 'Enter here' }, smallest: { type: String, default: 'col-12' }, small: { type: String, default: 'col-sm-12' }, medium: { type: String, default: 'col-md-12' }, large: { type: String, default: 'col-lg-12' }, largest: { type: String, default: 'col-lg-12' },
    },
    components: {
        [Input.name]: Input,
        [Popover.name]: Popover,
        'disabled-value': DisabledValue
    },
    computed: {
        column_class() {
            return `${this.largest} ${this.large} ${this.medium} ${this.small} ${this.smallest}`
        },
        label_class_value() {
            return "float-left"
        },
        // Highlight only fields the user has interacted with, or fields that already hold a (prefilled)
        // value - an untouched empty field on a fresh form stays unhighlighted even when mandatory.
        show_error_highlight() {
            return this.highlight_invalid_fields
                && !this.prop_valid
                && (this.touched || !!this.prop_value);
        }
    },
    watch: {
        value: { // watch it
            immediate: true,
            handler(val, oldVal) {
                this.prop_value = val;
                if (val != oldVal) {
                    this.handler_change(true);
                }
            }
        }
    },
    data() {
        return {
            is_processing: false,
            replace_min_length: '-min_length-',
            replace_max_length: '-max_length-',
            replace_field_name: '-field_name-',

            warning_email: 'This is not valid email value. Please check it and fix mistake',
            warning_url: 'This is not valid url address, it returns no response',
            warning_length: "",
            warning_min_length: "",
            warning_max_length: "",
            warning_mandatory: "This field is mandatory to fill",

            prop_value: "",
            prop_valid: true,
            touched: false
        };
    },
    methods: {
        on_user_change() {
            this.touched = true;
            this.handler_change();
        },
        on_user_input() {
            this.touched = true;
            this.validate(true);
        },
        validate(isLiveInput) {
            let new_warnings = [];
            if ((!this.is_mandatory && !this.is_mandatory_if_visible && !this.prop_value) || this.disabled) {
                this.prop_valid = true;
            } else {
                if ((this.is_mandatory || this.is_mandatory_if_visible) && !this.prop_value && !this.min_length && !this.max_length) {
                    new_warnings.push(this.warning_mandatory);
                }

                if (this.min_length || this.max_length) {
                    let templateWarning = "";
                    if (this.max_length &&
                        this.min_length) {

                        if (!this.prop_value ||
                            this.prop_value.length < this.min_length ||
                            this.prop_value.length > this.max_length) {
                            templateWarning = this.warning_length;
                        }
                    }
                    else
                        if (this.max_length) {
                            if (!this.prop_value ||
                                this.prop_value.length > this.max_length) {
                                templateWarning = this.warning_max_length;
                            }
                        }
                        else {
                            if (!this.prop_value ||
                                this.prop_value.length < this.min_length) {
                                templateWarning = this.warning_min_length;
                            }
                        }

                    if (templateWarning) {
                        new_warnings.push(templateWarning);
                    }
                }

                if (this.email && this.prop_value && !this.validate_email(this.prop_value)) {
                    new_warnings.push(this.warning_email);
                }


                if (this.link && this.prop_value) {
                    let oldValue = "";
                    if (!isLiveInput && this.prop_value.indexOf("http") != 0) {
                        oldValue = this.prop_value;
                        this.prop_value = "https://" + this.prop_value;
                    }
                    if (!this.validate_link(this.prop_value)) {
                        if (oldValue) {
                            this.prop_value = oldValue;
                        }
                        new_warnings.push(this.warning_url);
                    }
                }

                this.prop_valid = !new_warnings.length;
            }

            this.$emit("update:valid", this.prop_valid);
            this.$emit("update:error_messages", new_warnings);

        },
        validate_link(link) {
            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
            return !!pattern.test(link);
        },
        run_clear(array) {
            if (array && array.length) {
                array.forEach(item => EventBus.$emit(`clear-value-field-id-${item}`));
            }
        },
        validate_user() {
            if (!this.prop_value && !this.is_mandatory) {
                this.update_error();
                return;
            }

            var self = this;
            self.is_processing = true;
            self.run_clear(self.update_fields);
            request[self.api](this.prop_value, this.code_value)
                .then(response => {
                    self.is_processing = false;
                    if (response && response.body && response.body.outputData) {
                        self.update_error();
                        let model = response.body.outputData;

                        if (self.update_fields && self.update_fields.length) {
                            self.update_fields.forEach((id, index) =>
                                EventBus.$emit(`update-value-field-id-${id}`, model[self.update_fields_map[index]]));
                        }
                    }
                    else {
                        if (response && response.body && response.body.message) {
                            self.update_error(response.body.message)
                        } else {
                            self.update_error("Validation failed. Reason is unknown.")
                        }
                    }
                },
                    error => {
                        self.is_processing = false;
                        self.add_error("Server is not responded. Unable to process this request.")
                    });
        },
        update_error(message) {
            if (message) {
                this.prop_valid = false;
                this.$emit("update:valid", false);
                this.$emit("update:error_messages", [message]);
            }
            else {
                this.prop_valid = true;
                this.$emit("update:valid", true);
                this.$emit("update:error_messages", []);
            }
        },
        validate_email(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        handler_change(skipClear) {
            if (!this.is_processing && this.api) {

                if (this.prop_value) {
                    this.update_error("Data validation in process");
                }
                this.validate_user();
            }

            if (!skipClear && !this.is_processing && this.clear_fields && this.clear_fields.length) {
                this.run_clear(this.clear_fields);
            }

            this.validate();
            this.$emit("update:value", this.prop_value);
        },
        remove_tab_index() {
            if (this.$refs && Object.keys(this.$refs).length) {
                Object.keys(this.$refs).forEach(prop => {
                    if (this.$refs[prop] && this.$refs[prop].$el && this.$refs[prop].$el.children && this.$refs[prop].$el.children.length) {
                        this.$refs[prop].$el.children[1].tabIndex = -1;
                    }
                })
            }
        },
        get_input_class() {
            return { 'text-copy': this.is_text_copy, 'mb-2': this.is_text_area };
        }
    },
    mounted() {
        this.warning_length = `This field cannot be empty and its length should be between ${this.min_length} and ${this.max_length} characters long`;
        this.warning_min_length = `This field cannot be empty and its length should be more than ${this.min_length} characters long`;
        this.warning_max_length = `This field cannot be empty and its length should be until ${this.max_length} characters long`;

        this.handler_change(true);
        this.remove_tab_index();
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/answer-types/text/text.js